import { NgModule, Optional, SkipSelf, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AddTokenInterceptor, LoaderInterceptor, AuthErrorInterceptor } from './interceptors/index';

import {
  ApiService,
  ItrProfileService,
  StateService,
  BusinessService,
  LoadingService,
  UserService,
  SessionService,
  AuthGuardService,
  NotificationService,
  FormInputControlService,
  ItrSlipsService,
  ProvincialsService,
  PaymentsService,
  AdminAuthGuardService,
  AdminUserService,
  ItrDiscardGuardService
} from './services/index';

import {
  LoadingComponent
} from './components/index';

@NgModule({
  declarations: [
    LoadingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LoadingComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AddTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    ApiService,
    StateService,
    BusinessService,
    ItrProfileService,
    StateService,
    LoadingService,
    UserService,
    SessionService,
    AuthGuardService,
    NotificationService,
    FormInputControlService,
    ItrSlipsService,
    ProvincialsService,
    PaymentsService,
    AdminAuthGuardService,
    AdminUserService,
    ItrDiscardGuardService
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
 }
